import DetailButton from './DetailButton'

const Table = ({state, openModalDetail}) => {
  return (
    <div className="row mt-2">
      <div className="card col-xxl-12">
        <div className={`table-responsive ${state.loading ? 'table-loading-overlay' : ''}`}>
          <table className="table table-row-bordered table-payment-datail">
            <thead className="fs-4 text-gray-400">
              <tr>
                <th>N° Rol</th>
                <th>Nombre Paciente</th>
                <th>Fecha Hosp.</th>
                <th>Fecha Alta</th>
                <th>Previsión</th>
                <th>N° PAM</th>
                <th>Nombre Médico Tratante</th>
                <th>Acción</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody className="fs-4 text-gray-700">
              {state.data.length > 0 && state.data.map((row, index) => (
                <tr key={index}>
                  <td>{row.NumeroRol}</td>
                  <td>{row.Paciente}</td>
                  <td>{row.Fecha_Ingreso}</td>
                  <td>{row.Fecha_Alta}</td>
                  <td>{row.Nombre}</td>
                  <td>{row.Numero_PAM}</td>
                  <td>{row.Profesional}</td>
                  <td>
                    <div className="row">
                      <span style={{marginRight: '10px'}} className='col'> {row.Accion_Intervencion} </span>
                      <span style={{ cursor: "pointer" }} className='col' onClick={() => openModalDetail(row)}>
                        <DetailButton title={row.Accion_Intervencion} />
                      </span>
                    </div>
                  </td>
                  <td>{row.Parametro}</td>
                </tr>))}
              {[...Array(10 - state.data.length)].map((row, index) => (
                <tr key={index}>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default Table